import { Component, ElementRef, Input } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavParams } from 'ionic-angular';
import { AddCheckRegisterComponent } from '../check-register/add-check-register/add-check-register';
import { Rodeo } from '../../../model/rodeo';
import { OrganizationCheckRegister } from '../../../model/organizationCheckRegister';
import { OrganizationCheckRegisterService } from '../../../services/organization-check-service';
import { AlertMessager } from '../../../lib/alertMessager';
import { Observable } from 'rxjs';
import { PrintChecksComponent } from '../print-checks.component';
import { Winner } from '../../../model/winner';
import { Account } from '../../../model/account';

@Component({
  selector: 'check-register',
  templateUrl: 'check-register.html'
})
export class CheckRegisterComponent {
  @Input() viewMode: string;
  @Input() rodeo: Rodeo;
  organizationCheck: OrganizationCheckRegister[];
  filteredOrganizationCheck: OrganizationCheckRegister[];
  text: string;
  hideTable: boolean = false;
  textSearchChangeObservable: any;
  loading: any;
  amountFilter: string = '';
  nameFilter: string = '';
  checkFilter: string = '';
  dateFilter: string = '';
  searchText: string = '';

  nameSortAsc: boolean;
  nameSortDesc: boolean;
  checkSortAsc: boolean;
  checkSortDesc: boolean;

  constructor(
    private modalCtrl: ModalController,
    private alertController: AlertController,
    private alertMessager: AlertMessager,
    private loadingControl: LoadingController,
    private OrganizationCheckService: OrganizationCheckRegisterService
  ) { }

  ngOnInit() {
    if (this.rodeo && this.rodeo.organizationCheckRegister) {
      this.organizationCheck = this.rodeo.organizationCheckRegister;
      this.filteredOrganizationCheck = [...this.organizationCheck];
    }
  }

  openModal(checkRegister) {
    const rodeoInfo = {
      rodeoId: this.rodeo.id,
      organizationId: this.rodeo.organization.id
    };

    const modal = this.modalCtrl.create(
      AddCheckRegisterComponent,
      { rodeoInfo, formCheck: checkRegister },
      { cssClass: 'add-check-register' }
    );

    modal.onDidDismiss((data) => {
      if (data) {
        this.updateRegisterCheck(data);
      }
    });

    modal.present();
  }

  updateRegisterCheck(data) {
    var existingCheck = this.organizationCheck.filter(x => x.id == data.id);

    if (existingCheck.length > 0) {
      this.organizationCheck[this.organizationCheck.indexOf(existingCheck[0])] = data;
    } else {
      this.organizationCheck.push(data);
    }
    
    this.filteredOrganizationCheck = this.organizationCheck;
  }

  onEntrySearchChange(searchValue: string) {
    if (!this.textSearchChangeObservable) {
      Observable.create(observer => {
        this.textSearchChangeObservable = observer;
      })
        .debounceTime(500)
        .distinctUntilChanged()
        .subscribe((text) => {
          this.search();
        });
    }
    this.textSearchChangeObservable.next(searchValue);
  }

  toggleNameSort() {
    if (this.nameSortAsc) {
        this.nameSortAsc = false;
        this.nameSortDesc = true;
    } else {
        this.nameSortAsc = true;
        this.nameSortDesc = false;
        this.checkSortAsc = false;
        this.checkSortDesc = false;
    }

    this.sortCheckRegister();
}

toggleCheckSort() {
    if (this.checkSortAsc) {
        this.checkSortAsc = false;
        this.checkSortDesc = true;
    } else {
        this.nameSortAsc = false;
        this.nameSortDesc = false;
        this.checkSortAsc = true;
        this.checkSortDesc = false;
    }

    this.sortCheckRegister();
}

  search() {
    this.loading = this.loadingControl.create({
      content: 'Applying Filters...'
    });
    this.loading.present();

    if (!this.amountFilter && !this.nameFilter && !this.checkFilter && !this.dateFilter) {
      this.filteredOrganizationCheck = [...this.organizationCheck];
    } else {
      this.filteredOrganizationCheck = this.organizationCheck;

      if (this.amountFilter !== null && this.amountFilter !== undefined && this.amountFilter !== '') {
        this.filteredOrganizationCheck = this.filteredOrganizationCheck.filter(
          item => item.amount.toString() === this.amountFilter
        );
      }

      if (this.nameFilter !== null && this.nameFilter !== undefined && this.nameFilter !== '') {
        this.filteredOrganizationCheck = this.filteredOrganizationCheck.filter(
          item => item.name.toLowerCase().includes(this.nameFilter.toLowerCase())
        );
      }

      if (this.checkFilter !== null && this.checkFilter !== undefined && this.checkFilter !== '') {
        this.filteredOrganizationCheck = this.filteredOrganizationCheck.filter(item =>
          item.checkNumber.includes(this.checkFilter)
        );
      }

      if (this.dateFilter !== null && this.dateFilter !== undefined && this.dateFilter !== '') {
        const formattedDate = this.dateFilter.split('T')[0];

        this.filteredOrganizationCheck = this.filteredOrganizationCheck.filter(item =>
          item.datePrinted.includes(formattedDate)
        );
      }
    }

    this.sortCheckRegister();

    this.loading.dismiss();
  }

  sortCheckRegister() {
    this.filteredOrganizationCheck = this.filteredOrganizationCheck.sort((n1, n2) => {
      if (this.checkSortAsc || this.checkSortDesc) {
          if (+n1.checkNumber < +n2.checkNumber)
              return this.checkSortDesc ? 1 : -1;
          else if (+n1.checkNumber > +n2.checkNumber)
              return this.checkSortDesc ? -1 : 1;

          if (n1.id < n2.id)
              return -1;
          else if (n1.id > n2.id)
              return 1;
      } else if (this.nameSortAsc || this.nameSortDesc) {
          if (n1.name.toLowerCase() < n2.name.toLowerCase())
              return this.nameSortDesc ? 1 : -1;
          else if (n1.name.toLowerCase() > n2.name.toLowerCase())
              return this.nameSortDesc ? -1 : 1;

          if (n1.id < n2.id)
              return -1;
          else if (n1.id > n2.id)
              return 1;
      }
  });
  }

  onNameSearchChange(searchValue: string) {
    this.onEntrySearchChange(searchValue);
  }

  onCheckNumberSearchChange(searchValue: string) {
    this.onEntrySearchChange(searchValue);
  }

  onAmountSearchChange(searchValue: string) {
    this.onEntrySearchChange(searchValue);
  }

  onDatePrintedSearchChange(searchValue: string) {
    this.onEntrySearchChange(searchValue);
  }

  printCheck(checkRegister: OrganizationCheckRegister) {
    this.modalCtrl.create(
      PrintChecksComponent,
      { checksToPrint: [checkRegister], rodeo: this.rodeo, addToCheckRegister: false, startingCheckNum: +checkRegister.checkNumber },
      { cssClass: 'print-checks-modal' }
    ).present();
  }

  printOrganizationCheck() {
    this.hideTable = true;
    setTimeout(() => {
      new Promise((resolve, reject) => {
        const printContents = document.getElementById("print-check-register").outerHTML;
        const popupWin = window.open('', '', 'left=0,top=0,width=900,height=600,toolbar=0,scrollbars=0,status=0');

        let html = `
          <html>
            <head>
              <style>
                @media print {
                  .print-table {
                    border-collapse: collapse;
                    width: 100%;
                  }

                  .print-table td,
                  .print-table th {
                    border: 1px solid #ccc;
                    padding: 10px;
                  }

                  .print-table th {
                    background-color: #f0f0f0;
                    font-weight: normal;
                  }

                  .print-table .center-align,
                  .print-table .bold-text {
                    text-align: center;
                    vertical-align: top;
                  }

                  .print-table .center-align-voided {
                    text-align: center;
                    text-decoration: line-through;
                    vertical-align: top;
                  }

                  .print-table .bold-text {
                    background-color: #efefef;
                    font-weight: bold;
                  }
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `;

        popupWin.document.write(html);
        popupWin.document.close();
        setTimeout(() => {
          popupWin.focus();
          popupWin.print();
          popupWin.close();
          resolve(true);
        }, 1000);
      }).then(() => {
        this.hideTable = false;
      });
    }, 100);
  }
}



// WEBPACK FOOTER //
// ./src/pages/print-checks/check-register/check-register.ts